<template>
  <router-view />
</template>
<script>
  export default {
    name: 'NotificacaoModule',
  }
</script>
